var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container-fluid py-3"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-8"},[_c('Upcoming')],1),_c('div',{staticClass:"col-lg-4"},[_c('MostPlayed')],1)])])])])}
var staticRenderFns = []

export { render, staticRenderFns }